export default __webpack_public_path__ + "static/media/IMG_3183 copiee.f47861ee.jpg";